// src/components/integrations/synapse/SynapseViewerUtils.ts

/**
 * Helper function to get status color for Material UI components
 * @param status The workflow status string
 * @returns Material UI color name ('success', 'error', or 'warning')
 */
export const getStatusColor = (status: string): 'success' | 'error' | 'warning' => {
    switch (status.toLowerCase()) {
        case 'succeeded':
            return 'success';
        case 'failed':
            return 'error';
        case 'in_progress':
        case 'processing':
        default:
            return 'warning';
    }
};

/**
 * Helper function to get display status
 * @param status The workflow status string
 * @returns Human-readable status string
 */
export const getDisplayStatus = (status: string): string => {
    if (!status || status.toLowerCase() === 'unspecified' || status.toLowerCase() === 'in_progress') {
        return 'In progress';
    }
    return status;
};

/**
 * Format file size in human-readable format
 * @param bytes File size in bytes
 * @returns Formatted file size string (e.g., "1.5 MB")
 */
export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * Check if a file is a FASTQ file based on its extension
 * @param fileName The file name to check
 * @returns True if the file is a FASTQ file, false otherwise
 */
export const isFastqFile = (fileName: string): boolean => {
    const lowerName = fileName.toLowerCase();
    return lowerName.endsWith('.fastq.gz') || lowerName.endsWith('.fq.gz');
};
